import {BaseFilter} from "./base.filter";

export class DataEntityFilter extends BaseFilter {
  type: any;
}

export enum DataEntityType {
  Carriers,
  Clients,
  Collections,
  Consignees,
  Deliveries,
  Exporters,
  LoadingAddresses,
  Notifies,
  PortAddresses,
  Restitutions,
  TransportCompanies
}


